<div class="bg-surface-50 dark:bg-surface-950 px-6 py-20 md:px-12 lg:px-20">
	<div class="flex flex-col gap-6 pb-6">
		<div class="flex flex-col items-center gap-4 text-center">
			<app-headline-large [title]="content.title"></app-headline-large>
			<div class="flex flex-col gap-4 w-full lg:w-3/4">
				<app-body-large [description]="content.description"></app-body-large>
			</div>
		</div>

		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
			@let list = list$ | async; @if (list) { @for(state of list.states; track state.name) {
			<div class="bg-surface-50 dark:bg-surface-900 shadow-sm p-1 flex flex-col gap-2">
				<div class="flex-1 p-1 flex flex-col gap-2">
					<div class="flex justify-center gap-2">
						<h3
							class="text-base font-semibold text-surface-900 dark:text-surface-0 leading-tight m-0">
							{{ state.name | uppercase }}
						</h3>
					</div>
					<div class="flex flex-row flex-wrap justify-center">
						@for(city of state.cities; track city.name) {
						<p class="text-sm font-normal text-surface-700 dark:text-surface-100 leading-normal m-0 mx-2">
							<a [routerLink]="[state.abv.toLowerCase(), city.name.toLowerCase().replaceAll(' ', '-')]">{{city.name}}</a>
						</p>
						}
					</div>
				</div>
			</div>
			} }
		</div>
	</div>
</div>
